import React from 'react';
import { http, ConfigContext } from '../../base-ui/lib.js';
import { ListDocuments } from './listDocments.js';

export function DocubeeTest() {
	const { config }: any = React.useContext(ConfigContext);
	const [file, setFile] = React.useState<File | null>(null);

	async function handleFileUpload() {
		if (!file) {
			alert('Please select a file to upload.');
			return;
		}
		const formData = new FormData();
		formData.append('document', file);

		await http.post(formData, `${config.uri.base}/esign/upload`, {
			enctype: 'multipart/form-data',
		});

		return;
	}

	async function handleAddReplacementVariables() {
		const variables = {
			'list-materials': true,
			'Material-1': "6' solid TimberTech Terrain 2 board",
			'Material-2': "6' solid TimberTech Terrain 3 board",
			'Material-3': "6' solid TimberTech Terrain 4 board",
			'Amount-1': '$10',
			'Amount-2': '$20',
			'Amount-3': '$200',
		};
		await http.post(
			{ variables, documentId: '8edd547b-79fc-4d35-a38c-50ec73697652' },
			`${config.uri.base}/esign/replacement-variables`
		);
	}

	async function handleSetDocumentFields() {
		const fields = [
			{
				name: 'Client Signature',
				anchorString: 'client signature',
				type: 'signature',
				required: true,
			},
			{
				name: 'Client Signature Date',
				anchorString: 'client sign date',
				type: 'date',
				required: true,
			},
			{
				name: 'Contractor Signature',
				anchorString: 'contractor signature',
				type: 'signature',
				required: true,
			},
			{
				name: 'Contractor Signature Date',
				anchorString: 'contractor sign date',
				type: 'date',
				required: true,
			},
		];

		await http.post(
			{
				fields,
				documentId: '41834a32-37cc-49f1-9e1a-4977e5573970',
				formDefinitionId: 'docubee-test',
			},
			`${config.uri.base}/esign/fields`
		);
	}

	async function handleStartSignatureProcess() {
		const data = {
			documents: [
				{
					documentId: '149028e1-dceb-4c88-8b75-56afe89ac883',
					formDefinitionId: 'docubee-test',
				},
			],
			signers: [
				{
					label: 'Client',
					contactMethod: [
						{
							type: 'email',
							email: 'barron.brock@griffinglobaltech.com',
						},
					],
				},
				{
					label: 'Contractor',
					contactMethod: [
						{
							type: 'email',
							email: 'barron.von.brock@gmail.com',
						},
					],
				},
			],
			other: {
				testMode: true,
				processName: 'Quick Sign Process test',
				onSignaturesFinalized: [
					{
						type: 'email',
						email: 'barron.brock@griffinglobaltech.com',
					},
				],
			},
		};

		await http.post(data, `${config.uri.base}/esign/start`);
	}

	async function handleEndtoEndExample() {
		if (!file) {
			alert('Please select a file to upload.');
			return;
		}
		const formData = new FormData();
		formData.append('document', file);

		await http.post(formData, `${config.uri.base}/esign/endToEnd`, {
			enctype: 'multipart/form-data',
		});
	}

	async function handleS3IntegrationTest() {
		await http.post({}, `${config.uri.base}/esign/fakeS3`);
	}

	return (
		<div className="flex flex-col items-center justify-center h-screen">
			<h1 className="text-2xl font-bold mb-4">Docubee Test Page</h1>
			<p className="text-lg">This is a test page for Docubee integration.</p>
			<a
				href="https://docubee.com"
				className="mt-4 text-blue-500 hover:underline"
			>
				Visit Docubee
			</a>

			<input
				type="file"
				accept=".docx"
				onChange={(e) => setFile(e.target.files?.[0] || null)}
			/>

			<button onClick={handleFileUpload} className="mt-4 btn-primary">
				Upload File
			</button>

			<button
				onClick={handleAddReplacementVariables}
				className="mt-4 btn-primary"
			>
				Add replacement variables
			</button>

			<button onClick={handleSetDocumentFields} className="mt-4 btn-primary">
				Set Document Fields
			</button>

			<button
				onClick={handleStartSignatureProcess}
				className="mt-4 btn-primary"
			>
				Start Signature Process
			</button>

			<button onClick={handleEndtoEndExample} className="mt-4 btn-primary">
				End To End example
			</button>

			<button onClick={handleS3IntegrationTest} className="mt-4 btn-primary">
				Test s3 integration
			</button>

			<ListDocuments />
		</div>
	);
}
